import React, {Component} from 'react'
import {Breadcrumb} from 'antd'
import pathToRegexp from 'path-to-regexp';
import {Link} from 'react-router-dom'
import styles from './index.module.css'
import urlToList from '../../utils/urlToList'

class PageHeader extends Component {

    state = {
        breadcrumb: null
    };

    componentDidMount() {
        this.getBreadcrumbDom()
    }

    getBreadcrumbDom = () => {
        const {routes, location} = this.props;
        const pathSnippets = urlToList(location.pathname);
        const extraBreadcrumbItems = pathSnippets.map((url, index) => {
            const pathRegexp = pathToRegexp(url);
            const currentBreadcrumb = this.getBreadcrumb(routes, pathRegexp);
            const isLinkable = index !== pathSnippets.length - 1 && currentBreadcrumb.component;
            return currentBreadcrumb.name ? (
                <Breadcrumb.Item key={url}>
                    {isLinkable ? (<Link to={url}>{currentBreadcrumb.name}</Link>) : currentBreadcrumb.name}
                </Breadcrumb.Item>
            ) : null
        });
        extraBreadcrumbItems.unshift(
            <Breadcrumb.Item key={'home'}>
                <Link to={'/'}>首页</Link>
            </Breadcrumb.Item>
        );
        const breadcrumb = (
            <Breadcrumb>
                {extraBreadcrumbItems}
            </Breadcrumb>
        );
        this.setState({
            breadcrumb
        });
    };

    getBreadcrumb = (routes, url) => {
        let breadcrumb = routes[url];
        if (!breadcrumb) {
            const pathRegexp = pathToRegexp(url)
            Object.keys(routes).forEach(item => {
                if (pathRegexp.test(item)) {
                    breadcrumb = routes[item];
                }
            });
        }
        return breadcrumb || {};
    };

    render() {
        return (
            <div className={styles.container}>
                <div className={styles.breadcrumb}>
                    {this.state.breadcrumb}
                </div>
                <div>
                    {this.props.title && <h1 className={styles.title}>{this.props.title}</h1>}
                </div>
                {this.props.content && (
                    <div style={{margin: 15}}>
                        {this.props.content}
                    </div>
                )}
            </div>
        )
    }
}

export default PageHeader